'use strict';

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - The ajax response from clicking the add to cart button
 */

function handlePostCartAdd(response) {
  $('.minicart').trigger('count:update', response);
  $('.js-cart-bag').addClass('full-cart');
  let msg = response.message || response.msg;
  let messageType = response.error ? 'alert-danger' : 'alert-success';
  // show add to cart toast
  if (response.newBonusDiscountLineItem && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
    chooseBonusProducts(response.newBonusDiscountLineItem);
  } else {
    if ($('.add-to-cart-messages').length === 0) {
      $('.offer-add-to-cart').parent().parent().append('<div class="add-to-cart-messages col-sm-12"></div>');
    }

    $('.add-to-cart-messages').append('<div class="alert ' + messageType + ' add-to-basket-alert card-custom text-center" role="alert">' + msg + '</div>');

    setTimeout(function () {
      $('.add-to-basket-alert').remove();
    }, 5000);
  }
}

/**
 * Returns price value
 * @param {models.price.default.DefaultPrice} priceModel - The price model
 * @returns {number} The price value
 */
function getPrice(priceModel) {
  return !priceModel.sales ? priceModel.list.value : priceModel.sales.value;
}

/**
 * Returns list price value
 * @param {models.price.default.DefaultPrice} priceModel - The price model
 * @returns {number} The list price value
 */
function getListPrice(priceModel) {
  return priceModel.list ? priceModel.list.value : '';
}

function getQuantitySelected($el) {
  return getQuantitySelector($el).val() || 1;
}

function getQuantitySelector($el) {
  let quantitySelected;
  if ($el && $('.set-items').length) {
    quantitySelected = $($el).closest('.product-detail').find('.quantity-select');
  } else if ($el && $('.product-bundle').length) {
    let quantitySelectedModal = $($el).closest('.modal-footer').find('.quantity-select');
    let quantitySelectedPDP = $($el).closest('.bundle-footer').find('.quantity-select');
    if (quantitySelectedModal.val() === undefined) {
      quantitySelected = quantitySelectedPDP;
    } else {
      quantitySelected = quantitySelectedModal;
    }
  } else {
    quantitySelected = $('.quantity-select');
  }
  return quantitySelected;
}

function canAddToCart() {
  if ($('#GiftCertificateForm').length > 0) {
    var purchaseAmountobj = $('input[name=dwfrm_giftcert_purchase_amount]');
    let giftcardFormInvalid =
      purchaseAmountobj.val() === '' ||
      parseInt(purchaseAmountobj.val()) < parseInt(purchaseAmountobj.attr('min')) ||
      parseInt(purchaseAmountobj.val()) > parseInt(purchaseAmountobj.attr('max')) ||
      $('input[name=dwfrm_giftcert_purchase_recipientEmail]').val() === '' ||
      ($('.recipient-select').val() === 'gift' &&
        ($('input[name=dwfrm_giftcert_purchase_recipientEmail]').val() === '' || $('input[name=dwfrm_giftcert_purchase_recipient]').val() === ''));
    if (giftcardFormInvalid) {
      $('.js-giftcard-submit').trigger('click');
      return false;
    } else {
      return true;
    }
  } else {
    const colorSelected = $('.color-attribute .color-value.selected');
    const sizeSelected = $('.select-size option.selected');
    return colorSelected.length > 0 && sizeSelected.length > 0;
  }
}

function showAddToCartError() {
  const selectColor = $('.color-attribute');
  const selectSize = $('.select-size');
  let colorError = false;

  if (selectColor.length > 0 && selectColor.find('.color-value.selected').length === 0) {
    selectColor.addClass('error');
    const msg = $(selectColor).data('error');
    if ($('.add-to-cart-messages').length === 0) {
      $('.offer-add-to-cart').parent().parent().append('<div class="add-to-cart-messages col-sm-12"></div>');
    }

    if (window.innerWidth < 1024) {
      colorError = true;
      selectColor
        .parent()
        .parent()
        .append('<div class="alert alert-danger add-to-basket-alert card-custom text-center js-color-error-scroll-anchor" role="alert">' + msg + '</div>');
      const yOffset = -200;
      const element = document.querySelector('.js-color-error-scroll-anchor');
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }

    $('.add-to-cart-messages').append('<div class="alert alert-danger add-to-basket-alert desktop card-custom text-center" role="alert">' + msg + '</div>');
    selectColor.attr('aria-describedby', 'color_error_message');
  }

  if (selectSize.length > 0 && selectSize.find('.option.selected').length === 0) {
    selectSize.addClass('error');
    const msg = $(selectSize).data('error');
    if ($('.add-to-cart-messages').length === 0) {
      $('.offer-add-to-cart').parent().parent().append('<div class="add-to-cart-messages col-sm-12"></div>');
    }

    if (window.innerWidth < 1024) {
      selectSize.parent().append('<div class="alert alert-danger add-to-basket-alert card-custom text-center js-size-error-scroll-anchor" role="alert">' + msg + '</div>');
      const yOffset = -200;
      const element = document.querySelector('.js-size-error-scroll-anchor');
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      if (!colorError) {
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }

    $('.add-to-cart-messages').append('<div class="alert alert-danger add-to-basket-alert desktop card-custom text-center" role="alert">' + msg + '</div>');
  }

  setTimeout(function () {
    $('.add-to-basket-alert').remove();
  }, 5000);
}

/**
 * Add an offer to the cart
 */
function addOfferToCart() {
  $(document).on('click', 'button.offer-add-to-cart', function () {
    let addToCartObject = $(this).attr('data-mirakl') ? JSON.parse($(this).attr('data-mirakl')) : null;

    if (!canAddToCart()) {
      showAddToCartError();
      return;
    }

    if (addToCartObject) {
      window.$.spinner().start();

      let addToCartUrl = addToCartObject.url;
      let pid = addToCartObject.pid;
      let priceInfo = addToCartObject.priceInfo;
      let productName = addToCartObject.productName;
      let channels = addToCartObject.channels;
      let price = getPrice(addToCartObject.price);
      let listPrice = getListPrice(addToCartObject.price);
      let operatorProductId;
      if ($('.modal.show .product-quickview').length) {
        operatorProductId = $('.modal.show').find('.product-quickview').data('pid');
      } else {
        operatorProductId = $('.product-id')[0].textContent;
      }
      let shopName = addToCartObject.shopName;
      let offerState = addToCartObject.offerState;
      let offerStateCode = addToCartObject.offerStateCode;
      let shopId = addToCartObject.shopId;
      let quantity = getQuantitySelected($(this));
      let form = {
        pid: pid,
        price: price,
        channels: channels,
        listPrice: listPrice,
        productName: productName,
        quantity: quantity,
        operatorProductId: operatorProductId,
        shopName: shopName,
        offerState: offerState,
        offerStateCode: offerStateCode,
        shopId: shopId,
        priceInfo: priceInfo,
      };

      $(this).trigger('updateAddToCartFormData', form);

      if (addToCartUrl) {
        $.ajax({
          url: addToCartUrl,
          method: 'POST',
          data: form,
          success: function (data) {
            handlePostCartAdd(data);
            $('body').trigger('product:afterAddToCart', data);
            $('.js-cart-bag .item-count').text(data.quantityTotal);
            $('.js-cart-bag').removeClass('hide');
            window.$.spinner().stop();
          },
          error: function (data) {
            handlePostCartAdd(data.responseJSON);
            window.$.spinner().stop();
            console.error(data.responseJSON);
          },
        });
      }
    }
  });
}

module.exports = {
  addOfferToCart: addOfferToCart,
};
